import { render, staticRenderFns } from "./FailedScreen.vue?vue&type=template&id=acf463fe&scoped=true"
import script from "./FailedScreen.vue?vue&type=script&lang=js"
export * from "./FailedScreen.vue?vue&type=script&lang=js"
import style0 from "./FailedScreen.vue?vue&type=style&index=0&id=acf463fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf463fe",
  null
  
)

export default component.exports